import React from 'react'
import { Card, Col, Row, Statistic } from 'antd'
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  FileOutlined,
  TrophyOutlined,
} from '@ant-design/icons'
import styled from 'styled-components'

interface GlobalKpis {
  totalCompleted: number
  totalClosed: number
  totalInProgress: number
  totalCreated: number
}

interface Props {
  kpis: GlobalKpis
}

const GlobalKpis = ({ kpis }: Props) => (
  <Row gutter={[16, 16]}>
    <Col xs={24} sm={12} lg={6}>
      <StyledCard>
        <Statistic
          title="Total créés"
          value={kpis.totalCreated}
          prefix={<FileOutlined />}
          valueStyle={{ color: '#1890ff' }}
        />
      </StyledCard>
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <StyledCard>
        <Statistic
          title="En cours"
          value={kpis.totalInProgress}
          prefix={<ClockCircleOutlined />}
          valueStyle={{ color: '#faad14' }}
        />
      </StyledCard>
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <StyledCard>
        <Statistic
          title="Validés (Greffe)"
          value={kpis.totalClosed}
          prefix={<CheckCircleOutlined />}
          valueStyle={{ color: '#52c41a' }}
        />
      </StyledCard>
    </Col>
    <Col xs={24} sm={12} lg={6}>
      <StyledCard>
        <Statistic
          title="Formalités terminées"
          value={kpis.totalCompleted}
          prefix={<TrophyOutlined />}
          valueStyle={{ color: '#13c2c2' }}
        />
      </StyledCard>
    </Col>
  </Row>
)

export default GlobalKpis

const StyledCard = styled(Card)`
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
`
